// src/components/StreakMiniBadge.tsx
import React from 'react';
import dayjs from 'dayjs';
import { Flame, Award, Trophy, LucideIcon } from 'lucide-react'; // LucideIconをインポート
import { useStreak } from '../../hooks/useStreak';

// Propsのインターフェースを定義
interface StreakMiniBadgeProps {
  userId: string;
}

const StreakMiniBadge: React.FC<StreakMiniBadgeProps> = ({ userId }) => {
  // useStreakフックの戻り値の型を明示
  const { streakDays, completionDateList }: { streakDays: number; completionDateList: string[] } = useStreak(userId);

  const today = dayjs();
  const yesterday = today.subtract(1, 'day').format('YYYY-MM-DD');
  const todayFormatted = today.format('YYYY-MM-DD');
  const hasRecent = completionDateList.includes(todayFormatted) || completionDateList.includes(yesterday);

  const displayDays = hasRecent ? streakDays : 0;

  let Icon: LucideIcon = Flame; // LucideIcon型を明示
  let colorClass: string = 'text-orange-600 bg-orange-100'; // string型を明示

  if (displayDays > 30) {
    Icon = Trophy;
    colorClass = 'text-purple-700 bg-purple-100';
  } else if (displayDays > 10) {
    Icon = Award;
    colorClass = 'text-yellow-700 bg-yellow-100';
  }

  return (
    <div
      className={`flex items-center space-x-1 font-semibold text-sm px-2 py-1 rounded-full shadow-sm ${colorClass}`}
      title={`連続記録 ${displayDays}日`}
    >
      <Icon size={18} />
      <span>{displayDays}日連続中</span>
    </div>
  );
};

export default StreakMiniBadge;